module.exports = __webpack_public_path__ + "img/description4.a5db1a3d.jpg";